import { useState, type FunctionComponent } from "react";
import { Input } from "../../../components/ui/input";
import SearchIcon from "../../../assets/svgs/common/search.svg";
import { Link } from "react-router-dom";
import { Button } from "../../../components/ui/button";
import { DataTableBrandComponents } from "./brand-table.components";
import { XIcon } from "lucide-react";

const DashboardBrandAdminPartial: FunctionComponent = () => {
	const [search, setSearch] = useState("");

	return (
		<div className="flex flex-col justify-start items-center bg-background p-8 w-full h-screen text-primary">
			<div className="flex justify-between items-center px-5 py-6 w-full">
				<p className="font-semibold text-2xl">Brands</p>
				<div className="flex items-center gap-5">
					<div className="relative flex items-center bg-bginput py-2 pl-5 border border-border rounded-10">
						<SearchIcon />
						<Input
							value={search}
							onChange={(e) => setSearch(e.target.value)}
							className="bg-transparent border-none w-96 font-semibold text-base placeholder:text-secondary"
							placeholder="Search by name, Instagram ID, and number"
						/>
						{search.trim().length > 0 && (
							<XIcon
								onClick={() => setSearch("")}
								className="right-5 absolute cursor-pointer"
							/>
						)}
					</div>
					<Link to="/admin/brands/add-brand">
						<Button className="bg-tertiarybuttonbg px-10 py-7 border border-border font-semibold">
							+ Add a brand
						</Button>
					</Link>
				</div>
			</div>
			<div className="pt-10 w-full">
				<DataTableBrandComponents search={search} />
			</div>
		</div>
	);
};

export default DashboardBrandAdminPartial;
